import {
  borderRadius,
  DropdownListItem,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { FlagIcon } from '~/components/flag-icon/FlagIcon';

export const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledDropdownListItem = styled(DropdownListItem)`
  ${DropdownListItem.Styled.MainLabel} {
    margin-right: 0;
  }
`;

export const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TitleAndSubtitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ExchangeAndClassWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
`;

export const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TickerLabel = styled.span`
  ${typographyV2.bodySm}
`;

export const ExchangeLabel = styled.span`
  ${typographyV2.bodyXs}
`;

export const NameLabel = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const AssetClassLabel = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const StyledAssetLogoContainer = styled(AssetLogoContainer)`
  ${borderRadius.rFull};
  border: 1px solid var(--border-soft);
`;

export const StyledFlagIcon = styled(FlagIcon)`
  width: 24px;
  height: 24px;
  ${borderRadius.rFull};
`;
